// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* VARIABLES GLOBALES */
:root {
    --primary-blue: #5038ED;
    --score-verde: #2FA86F;
    --score-naranja: #F97316;
    --score-rojo: #EF4444;

    /* Modo Claro */
    --app-fondo: #F3F4F6;       
    --bg-card: #FFFFFF;         
    --bg-input: #FFFFFF;        
    --texto-principal: #111827; 
    --color-gray-text: #6b7280; 
    --color-borders: #d1d5db;   
    --color-light-bg: #e5e7eb;  
    --sombra-card: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.06);
    --font-principal: 'Poppins', sans-serif;
}

/* Modo Oscuro */
body.dark-mode {
    --primary-blue: #6366f1; 
    --app-fondo: #111827;      
    --bg-card: #1F2937;        
    --bg-input: #374151;       
    --texto-principal: #F9FAFB; 
    --color-gray-text: #9CA3AF; 
    --color-borders: #374151;  
    --color-light-bg: #374151; 
    --sombra-card: 0 10px 15px -3px rgba(0, 0, 0, 0.5);
}

/* ESTILOS BASE Y ESTRUCTURA */
body {
    margin: 0;
    font-family: var(--font-principal);
    background-color: var(--app-fondo);
    color: var(--texto-principal);
    transition: background-color 0.3s ease, color 0.3s ease;
}

/* Reutilizamos la clase del contenedor para mantener consistencia */
.modern-login-container {
    display: flex;
    min-height: 100vh;
    width: 100%;
    background-color: var(--app-fondo);
    position: relative;
    overflow: hidden;
}

/* Fondo SVG (Lineas) */
.floating-paths-container {
    position: absolute;
    inset: 0;
    z-index: 0;
    opacity: 0.25;
    pointer-events: none;
    color: var(--primary-blue);
    transition: color 0.3s ease;
}

/* Animacion de spinning para el loader */
@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

.animate-spin {
    animation: spin 1s linear infinite;
}

/* PANEL IZQUIERDO (FORMULARIO) */
.login-left-panel {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    position: relative;
    z-index: 10;
}

.login-glow {
    position: absolute;
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, var(--primary-blue) 0%, transparent 70%);
    border-radius: 50%;
    top: -10%;
    left: -10%;
    opacity: 0.15;
    filter: blur(80px);
    pointer-events: none;
    z-index: -1;
    transition: background 0.3s ease;
}

.login-card {
    width: 100%;
    max-width: 420px;
    padding: 2.5rem;
    background-color: var(--bg-card);
    border: 1px solid var(--color-borders);
    border-radius: 24px;
    box-shadow: var(--sombra-card);
    display: flex;
    flex-direction: column;
    gap: 1.5rem; /* Reducido ligeramente vs Login porque hay más campos */
    transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
    position: relative;
    z-index: 2;
}

/* Elementos del Formulario */
.login-header { text-align: center; }
.icon-container {
    width: 50px; height: 50px;
    background-color: var(--color-light-bg);
    color: var(--primary-blue);
    border-radius: 12px;
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 1rem;
    font-size: 1.5rem;
    transition: background-color 0.3s ease, color 0.3s ease;
    animation: subtle-pulse 5s ease-in-out infinite;
}
.login-title { font-size: 2rem; font-weight: 700; margin: 0; color: var(--texto-principal); }
.login-subtitle { color: var(--color-gray-text); font-size: 0.9rem; margin-top: 0.5rem; }

.form-group { margin-bottom: 1rem; } /* Margen ajustado para registro */
.label-text {
    display: block; font-size: 0.75rem; text-transform: uppercase;
    letter-spacing: 0.05em; color: var(--color-gray-text);
    margin-bottom: 0.5rem; font-weight: 600;
}
.input-wrapper { position: relative; display: flex; align-items: center; }
.input-icon {
    position: absolute; left: 1rem;
    color: var(--color-gray-text); font-size: 1.1rem;
    transition: color 0.3s; z-index: 2;
}
.modern-input {
    width: 100%; padding: 14px 14px 14px 45px;
    background-color: var(--bg-input);
    border: 1px solid var(--color-borders);
    border-radius: 12px;
    color: var(--texto-principal);
    font-size: 1rem; outline: none;
    transition: all 0.3s ease;
}
.modern-input::placeholder { color: var(--color-gray-text); opacity: 0.7; }
.input-wrapper:focus-within .modern-input {
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 2px rgba(80, 56, 237, 0.1);
}
.input-wrapper:focus-within .input-icon { color: var(--primary-blue); }

.btn-modern {
    width: 100%; padding: 14px;
    border: none; border-radius: 12px;
    background-color: var(--primary-blue);
    color: #ffffff;
    font-size: 1rem; font-weight: 600;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    gap: 0.5rem;
    transition: filter 0.3s ease, transform 0.2s;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    margin-top: 1rem;
}
.btn-modern:hover:not(:disabled) { filter: brightness(1.1); transform: translateY(-1px); }
.btn-modern:disabled { background-color: var(--color-borders); color: var(--color-gray-text); cursor: not-allowed; box-shadow: none; }

.feedback-msg {
    padding: 0.75rem; border-radius: 8px; font-size: 0.875rem;
    display: flex; align-items: center; gap: 0.5rem; margin-bottom: 1rem;
}
.feedback-error {
    background-color: rgba(239, 68, 68, 0.1);
    border: 1px solid var(--score-rojo); color: var(--score-rojo);
}
.attempts-text { text-align: center; font-size: 0.8rem; color: var(--score-naranja); margin-top: 0.5rem; }
.register-link { text-align: center; font-size: 0.9rem; color: var(--color-gray-text); margin-top: 1rem;}
.register-link a { color: var(--primary-blue); text-decoration: none; font-weight: 600; transition: color 0.2s; }
.register-link a:hover { text-decoration: underline; }

/* PANEL DERECHO (Desktop) */
.login-right-panel { display: none; }

@media (min-width: 1024px) {
    .login-right-panel {
        flex: 1 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        background-color: transparent; 
        padding: 3rem;
        text-align: center;
        z-index: 10;
    }

    /* GRADIENTE ANIMADO DE FONDO - Modo Claro */
    .animated-gradient-bg {
        position: absolute;
        top: 0; left: 0; width: 100%; height: 100%;
        background: linear-gradient(
            135deg,
            #5038ED 0%,
            #7c68f1 25%,
            #9333ea 50%,
            #6b52ff 75%,
            #5038ED 100%
        );
        background-size: 400% 400%;
        opacity: 0.95;
        z-index: 0;
        transition: all 0.5s ease;
    }

    /* MODO OSCURO */
    body.dark-mode .animated-gradient-bg {
        /* Gradiente oscuro con toques sutiles de azul profundo */
        background: linear-gradient(
            135deg,
            #0a0e1a 0%,
            #121828 20%,
            #1a1f3a 40%,
            #0f1419 60%,
            #0a0e1a 100%
        );
        background-size: 400% 400%;
        opacity: 1;
    }

    /* Glows en modo oscuro */
    body.dark-mode .right-glow-top {
        opacity: 0.08;
        background: radial-gradient(
            circle, 
            rgba(99, 102, 241, 0.3) 0%,
            rgba(67, 56, 202, 0.15) 40%,
            transparent 70%
        );
        filter: blur(150px);
    }

    body.dark-mode .right-glow-bottom {
        opacity: 0.06;
        background: radial-gradient(
            circle, 
            rgba(79, 70, 229, 0.25) 0%,
            rgba(55, 48, 163, 0.12) 40%,
            transparent 70%
        );
        filter: blur(140px);
    }

    /* Overlay en modo oscuro*/
    body.dark-mode .right-panel-overlay {
        background: linear-gradient(
            135deg,
            rgba(10, 14, 26, 0.4) 0%,
            rgba(26, 31, 58, 0.3) 50%,
            rgba(15, 20, 25, 0.4) 100% 
        );
        backdrop-filter: blur(1px);
        -webkit-backdrop-filter: blur(1px);
    }

    body.dark-mode .image-gradient-mask {
        background: 
            linear-gradient(to right, 
                rgba(10, 14, 26, 0.9) 0%,
                transparent 15%, 
                transparent 85%, 
                rgba(10, 14, 26, 0.9) 100%
            ),
            linear-gradient(to bottom, 
                rgba(10, 14, 26, 0.7) 0%, 
                transparent 15%, 
                transparent 85%, 
                rgba(10, 14, 26, 0.7) 100%
            );
    }

    /* Texto en modo oscuro*/
    body.dark-mode .hero-title {
        color: #f0f4ff;
        text-shadow: 2px 2px 12px rgba(0, 0, 0, 0.6);
    }

    body.dark-mode .highlight-text {
        color: #c7d2fe;
        text-shadow: 0 0 25px rgba(99, 102, 241, 0.4);
    }

    body.dark-mode .hero-desc {
        color: rgba(226, 232, 240, 0.85);
        text-shadow: 0 4px 15px rgba(0, 0, 0, 0.6);
    }

    /* Botones en modo oscuro */
    body.dark-mode .animation-toggle-btn {
        background: rgba(30, 41, 59, 0.6);
        border: 1px solid rgba(99, 102, 241, 0.2);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
    }

    body.dark-mode .animation-toggle-btn:hover {
        background: rgba(30, 41, 59, 0.8);
        border-color: rgba(99, 102, 241, 0.3);
        box-shadow: 0 6px 25px rgba(0, 0, 0, 0.5);
    }

    /* DEGRADADO (modo claro) */
    .image-gradient-mask {
        position: absolute;
        inset: 0;
        background: 
            linear-gradient(to right, 
                rgba(80, 56, 237, 0.8) 0%, 
                transparent 15%, 
                transparent 85%, 
                rgba(80, 56, 237, 0.8) 100%
            ),
            linear-gradient(to bottom, 
                rgba(80, 56, 237, 0.6) 0%, 
                transparent 15%, 
                transparent 85%, 
                rgba(80, 56, 237, 0.6) 100%
            );
        z-index: 1.5;
        pointer-events: none;
        transition: background 0.5s ease;
    }
    
    /* OVERLAY / DIFUMINADO */
    .right-panel-overlay {
        position: absolute;
        inset: 0;
        background: linear-gradient(
            135deg,
            rgba(80, 56, 237, 0.1) 0%,
            rgba(124, 104, 241, 0.05) 50%,
            rgba(147, 51, 234, 0.1) 100%
        );
        backdrop-filter: blur(2px);
        -webkit-backdrop-filter: blur(2px);
        z-index: 2;
        transition: all 0.5s ease;
    }

    /* Glows decorativos */
    .right-glow-top, .right-glow-bottom {
        position: absolute;
        border-radius: 50%;
        background: radial-gradient(circle, rgba(255, 255, 255, 0.4) 0%, transparent 70%);
        filter: blur(120px);
        opacity: 0.3;
        pointer-events: none;
        z-index: 3;
        transition: all 0.5s ease;
        animation: glow-pulse 4s ease-in-out infinite;
    }
    
    .right-glow-top { 
        width: 600px; 
        height: 600px;
        top: -10%; 
        right: -10%; 
        animation-delay: 0s;
    }
    
    .right-glow-bottom { 
        width: 500px; 
        height: 500px;
        bottom: -10%; 
        left: -10%; 
        background: radial-gradient(circle, rgba(255, 255, 255, 0.35) 0%, transparent 70%);
        animation-delay: 2s;
    }

    /* CONTENIDO (Texto e Iconos) */
    .right-panel-content {
        position: relative;
        z-index: 10;
        max-width: 400px;
    }

    .hero-icon-box {
        animation: subtle-pulse 6s ease-in-out infinite;
    }

    .hero-icon-box:active {
        transform: scale(0.95);
        animation: none;
    }

    .hero-title {
        font-size: 2.5rem; 
        font-weight: 700; 
        line-height: 1.1;
        margin-bottom: 1.5rem; 
        color: #ffffff;
        text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
        transition: all 0.3s ease;
    }

    .highlight-text { 
        color: #ffffff;
        text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
        transition: all 0.3s ease;
    }

    .hero-desc {
        font-size: 1.1rem; 
        color: rgba(255, 255, 255, 0.9);
        line-height: 1.6;
        text-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
        transition: all 0.3s ease;
    }

    /* Botones */
    .animation-toggle-btn {
        position: absolute;
        bottom: 30px;
        right: 30px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.3);
        color: white;
        font-size: 1.2em;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 20;
        transition: all 0.3s ease;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    }

    .animation-toggle-btn:hover {
        background: rgba(255, 255, 255, 0.3);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    }
}

/* RESPONSIVE */
@media (max-width: 1023px) {
    .login-left-panel {
        padding: 1.5rem;
    }
    
    .login-card {
        padding: 2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Register/register.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,uBAAuB;IACvB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;;IAErB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;IACzB,oFAAoF;IACpF,uCAAuC;AAC3C;;AAEA,gBAAgB;AAChB;IACI,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA,8BAA8B;AAC9B;IACI,SAAS;IACT,kCAAkC;IAClC,kCAAkC;IAClC,6BAA6B;IAC7B,uDAAuD;AAC3D;;AAEA,oEAAoE;AACpE;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,yCAAyC;AACzC;IACI,OAAO,uBAAuB,EAAE;IAChC,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,kCAAkC;AACtC;;AAEA,iCAAiC;AACjC;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,4EAA4E;IAC5E,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,sCAAsC;IACtC,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,WAAW,EAAE,wDAAwD;IACrE,oFAAoF;IACpF,kBAAkB;IAClB,UAAU;AACd;;AAEA,6BAA6B;AAC7B,gBAAgB,kBAAkB,EAAE;AACpC;IACI,WAAW,EAAE,YAAY;IACzB,uCAAuC;IACvC,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;IAC3D,mBAAmB;IACnB,iBAAiB;IACjB,uDAAuD;IACvD,+CAA+C;AACnD;AACA,eAAe,eAAe,EAAE,gBAAgB,EAAE,SAAS,EAAE,6BAA6B,EAAE;AAC5F,kBAAkB,6BAA6B,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;;AAExF,cAAc,mBAAmB,EAAE,EAAE,kCAAkC;AACvE;IACI,cAAc,EAAE,kBAAkB,EAAE,yBAAyB;IAC7D,sBAAsB,EAAE,6BAA6B;IACrD,qBAAqB,EAAE,gBAAgB;AAC3C;AACA,iBAAiB,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACzE;IACI,kBAAkB,EAAE,UAAU;IAC9B,6BAA6B,EAAE,iBAAiB;IAChD,sBAAsB,EAAE,UAAU;AACtC;AACA;IACI,WAAW,EAAE,4BAA4B;IACzC,iCAAiC;IACjC,sCAAsC;IACtC,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe,EAAE,aAAa;IAC9B,yBAAyB;AAC7B;AACA,6BAA6B,6BAA6B,EAAE,YAAY,EAAE;AAC1E;IACI,iCAAiC;IACjC,4CAA4C;AAChD;AACA,0CAA0C,0BAA0B,EAAE;;AAEtE;IACI,WAAW,EAAE,aAAa;IAC1B,YAAY,EAAE,mBAAmB;IACjC,qCAAqC;IACrC,cAAc;IACd,eAAe,EAAE,gBAAgB;IACjC,eAAe;IACf,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;IAC3D,WAAW;IACX,4CAA4C;IAC5C,6CAA6C;IAC7C,gBAAgB;AACpB;AACA,mCAAmC,uBAAuB,EAAE,2BAA2B,EAAE;AACzF,uBAAuB,sCAAsC,EAAE,6BAA6B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAErI;IACI,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB;IACzD,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,mBAAmB;AACxE;AACA;IACI,wCAAwC;IACxC,mCAAmC,EAAE,wBAAwB;AACjE;AACA,iBAAiB,kBAAkB,EAAE,iBAAiB,EAAE,2BAA2B,EAAE,kBAAkB,EAAE;AACzG,iBAAiB,kBAAkB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE,gBAAgB,CAAC;AACxG,mBAAmB,0BAA0B,EAAE,qBAAqB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAChH,yBAAyB,0BAA0B,EAAE;;AAErD,4BAA4B;AAC5B,qBAAqB,aAAa,EAAE;;AAEpC;IACI;QACI,SAAO;QACP,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;QAClB,6BAA6B;QAC7B,aAAa;QACb,kBAAkB;QAClB,WAAW;IACf;;IAEA,4CAA4C;IAC5C;QACI,kBAAkB;QAClB,MAAM,EAAE,OAAO,EAAE,WAAW,EAAE,YAAY;QAC1C;;;;;;;SAOC;QACD,0BAA0B;QAC1B,aAAa;QACb,UAAU;QACV,yBAAyB;IAC7B;;IAEA,gBAAgB;IAChB;QACI,yDAAyD;QACzD;;;;;;;SAOC;QACD,0BAA0B;QAC1B,UAAU;IACd;;IAEA,yBAAyB;IACzB;QACI,aAAa;QACb;;;;;SAKC;QACD,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb;;;;;SAKC;QACD,mBAAmB;IACvB;;IAEA,0BAA0B;IAC1B;QACI;;;;;SAKC;QACD,0BAA0B;QAC1B,kCAAkC;IACtC;;IAEA;QACI;;;;;;;;;;;;aAYK;IACT;;IAEA,wBAAwB;IACxB;QACI,cAAc;QACd,4CAA4C;IAChD;;IAEA;QACI,cAAc;QACd,6CAA6C;IACjD;;IAEA;QACI,gCAAgC;QAChC,0CAA0C;IAC9C;;IAEA,2BAA2B;IAC3B;QACI,iCAAiC;QACjC,yCAAyC;QACzC,yCAAyC;IAC7C;;IAEA;QACI,iCAAiC;QACjC,qCAAqC;QACrC,yCAAyC;IAC7C;;IAEA,2BAA2B;IAC3B;QACI,kBAAkB;QAClB,QAAQ;QACR;;;;;;;;;;;;aAYK;QACL,YAAY;QACZ,oBAAoB;QACpB,gCAAgC;IACpC;;IAEA,yBAAyB;IACzB;QACI,kBAAkB;QAClB,QAAQ;QACR;;;;;SAKC;QACD,0BAA0B;QAC1B,kCAAkC;QAClC,UAAU;QACV,yBAAyB;IAC7B;;IAEA,sBAAsB;IACtB;QACI,kBAAkB;QAClB,kBAAkB;QAClB,iFAAiF;QACjF,mBAAmB;QACnB,YAAY;QACZ,oBAAoB;QACpB,UAAU;QACV,yBAAyB;QACzB,6CAA6C;IACjD;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,SAAS;QACT,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,UAAU;QACV,kFAAkF;QAClF,mBAAmB;IACvB;;IAEA,+BAA+B;IAC/B;QACI,kBAAkB;QAClB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;QAChB,qBAAqB;QACrB,cAAc;QACd,2CAA2C;QAC3C,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,8CAA8C;QAC9C,yBAAyB;IAC7B;;IAEA;QACI,iBAAiB;QACjB,+BAA+B;QAC/B,gBAAgB;QAChB,0CAA0C;QAC1C,yBAAyB;IAC7B;;IAEA,YAAY;IACZ;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,oCAAoC;QACpC,2BAA2B;QAC3B,0CAA0C;QAC1C,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;QACX,yBAAyB;QACzB,yCAAyC;IAC7C;;IAEA;QACI,oCAAoC;QACpC,yCAAyC;IAC7C;AACJ;;AAEA,eAAe;AACf;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* VARIABLES GLOBALES */\r\n:root {\r\n    --primary-blue: #5038ED;\r\n    --score-verde: #2FA86F;\r\n    --score-naranja: #F97316;\r\n    --score-rojo: #EF4444;\r\n\r\n    /* Modo Claro */\r\n    --app-fondo: #F3F4F6;       \r\n    --bg-card: #FFFFFF;         \r\n    --bg-input: #FFFFFF;        \r\n    --texto-principal: #111827; \r\n    --color-gray-text: #6b7280; \r\n    --color-borders: #d1d5db;   \r\n    --color-light-bg: #e5e7eb;  \r\n    --sombra-card: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.06);\r\n    --font-principal: 'Poppins', sans-serif;\r\n}\r\n\r\n/* Modo Oscuro */\r\nbody.dark-mode {\r\n    --primary-blue: #6366f1; \r\n    --app-fondo: #111827;      \r\n    --bg-card: #1F2937;        \r\n    --bg-input: #374151;       \r\n    --texto-principal: #F9FAFB; \r\n    --color-gray-text: #9CA3AF; \r\n    --color-borders: #374151;  \r\n    --color-light-bg: #374151; \r\n    --sombra-card: 0 10px 15px -3px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n/* ESTILOS BASE Y ESTRUCTURA */\r\nbody {\r\n    margin: 0;\r\n    font-family: var(--font-principal);\r\n    background-color: var(--app-fondo);\r\n    color: var(--texto-principal);\r\n    transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n/* Reutilizamos la clase del contenedor para mantener consistencia */\r\n.modern-login-container {\r\n    display: flex;\r\n    min-height: 100vh;\r\n    width: 100%;\r\n    background-color: var(--app-fondo);\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n/* Fondo SVG (Lineas) */\r\n.floating-paths-container {\r\n    position: absolute;\r\n    inset: 0;\r\n    z-index: 0;\r\n    opacity: 0.25;\r\n    pointer-events: none;\r\n    color: var(--primary-blue);\r\n    transition: color 0.3s ease;\r\n}\r\n\r\n/* Animacion de spinning para el loader */\r\n@keyframes spin {\r\n    from { transform: rotate(0deg); }\r\n    to { transform: rotate(360deg); }\r\n}\r\n\r\n.animate-spin {\r\n    animation: spin 1s linear infinite;\r\n}\r\n\r\n/* PANEL IZQUIERDO (FORMULARIO) */\r\n.login-left-panel {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 2rem;\r\n    position: relative;\r\n    z-index: 10;\r\n}\r\n\r\n.login-glow {\r\n    position: absolute;\r\n    width: 500px;\r\n    height: 500px;\r\n    background: radial-gradient(circle, var(--primary-blue) 0%, transparent 70%);\r\n    border-radius: 50%;\r\n    top: -10%;\r\n    left: -10%;\r\n    opacity: 0.15;\r\n    filter: blur(80px);\r\n    pointer-events: none;\r\n    z-index: -1;\r\n    transition: background 0.3s ease;\r\n}\r\n\r\n.login-card {\r\n    width: 100%;\r\n    max-width: 420px;\r\n    padding: 2.5rem;\r\n    background-color: var(--bg-card);\r\n    border: 1px solid var(--color-borders);\r\n    border-radius: 24px;\r\n    box-shadow: var(--sombra-card);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1.5rem; /* Reducido ligeramente vs Login porque hay más campos */\r\n    transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;\r\n    position: relative;\r\n    z-index: 2;\r\n}\r\n\r\n/* Elementos del Formulario */\r\n.login-header { text-align: center; }\r\n.icon-container {\r\n    width: 50px; height: 50px;\r\n    background-color: var(--color-light-bg);\r\n    color: var(--primary-blue);\r\n    border-radius: 12px;\r\n    display: flex; align-items: center; justify-content: center;\r\n    margin: 0 auto 1rem;\r\n    font-size: 1.5rem;\r\n    transition: background-color 0.3s ease, color 0.3s ease;\r\n    animation: subtle-pulse 5s ease-in-out infinite;\r\n}\r\n.login-title { font-size: 2rem; font-weight: 700; margin: 0; color: var(--texto-principal); }\r\n.login-subtitle { color: var(--color-gray-text); font-size: 0.9rem; margin-top: 0.5rem; }\r\n\r\n.form-group { margin-bottom: 1rem; } /* Margen ajustado para registro */\r\n.label-text {\r\n    display: block; font-size: 0.75rem; text-transform: uppercase;\r\n    letter-spacing: 0.05em; color: var(--color-gray-text);\r\n    margin-bottom: 0.5rem; font-weight: 600;\r\n}\r\n.input-wrapper { position: relative; display: flex; align-items: center; }\r\n.input-icon {\r\n    position: absolute; left: 1rem;\r\n    color: var(--color-gray-text); font-size: 1.1rem;\r\n    transition: color 0.3s; z-index: 2;\r\n}\r\n.modern-input {\r\n    width: 100%; padding: 14px 14px 14px 45px;\r\n    background-color: var(--bg-input);\r\n    border: 1px solid var(--color-borders);\r\n    border-radius: 12px;\r\n    color: var(--texto-principal);\r\n    font-size: 1rem; outline: none;\r\n    transition: all 0.3s ease;\r\n}\r\n.modern-input::placeholder { color: var(--color-gray-text); opacity: 0.7; }\r\n.input-wrapper:focus-within .modern-input {\r\n    border-color: var(--primary-blue);\r\n    box-shadow: 0 0 0 2px rgba(80, 56, 237, 0.1);\r\n}\r\n.input-wrapper:focus-within .input-icon { color: var(--primary-blue); }\r\n\r\n.btn-modern {\r\n    width: 100%; padding: 14px;\r\n    border: none; border-radius: 12px;\r\n    background-color: var(--primary-blue);\r\n    color: #ffffff;\r\n    font-size: 1rem; font-weight: 600;\r\n    cursor: pointer;\r\n    display: flex; align-items: center; justify-content: center;\r\n    gap: 0.5rem;\r\n    transition: filter 0.3s ease, transform 0.2s;\r\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\r\n    margin-top: 1rem;\r\n}\r\n.btn-modern:hover:not(:disabled) { filter: brightness(1.1); transform: translateY(-1px); }\r\n.btn-modern:disabled { background-color: var(--color-borders); color: var(--color-gray-text); cursor: not-allowed; box-shadow: none; }\r\n\r\n.feedback-msg {\r\n    padding: 0.75rem; border-radius: 8px; font-size: 0.875rem;\r\n    display: flex; align-items: center; gap: 0.5rem; margin-bottom: 1rem;\r\n}\r\n.feedback-error {\r\n    background-color: rgba(239, 68, 68, 0.1);\r\n    border: 1px solid var(--score-rojo); color: var(--score-rojo);\r\n}\r\n.attempts-text { text-align: center; font-size: 0.8rem; color: var(--score-naranja); margin-top: 0.5rem; }\r\n.register-link { text-align: center; font-size: 0.9rem; color: var(--color-gray-text); margin-top: 1rem;}\r\n.register-link a { color: var(--primary-blue); text-decoration: none; font-weight: 600; transition: color 0.2s; }\r\n.register-link a:hover { text-decoration: underline; }\r\n\r\n/* PANEL DERECHO (Desktop) */\r\n.login-right-panel { display: none; }\r\n\r\n@media (min-width: 1024px) {\r\n    .login-right-panel {\r\n        flex: 1;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        align-items: center;\r\n        position: relative;\r\n        background-color: transparent; \r\n        padding: 3rem;\r\n        text-align: center;\r\n        z-index: 10;\r\n    }\r\n\r\n    /* GRADIENTE ANIMADO DE FONDO - Modo Claro */\r\n    .animated-gradient-bg {\r\n        position: absolute;\r\n        top: 0; left: 0; width: 100%; height: 100%;\r\n        background: linear-gradient(\r\n            135deg,\r\n            #5038ED 0%,\r\n            #7c68f1 25%,\r\n            #9333ea 50%,\r\n            #6b52ff 75%,\r\n            #5038ED 100%\r\n        );\r\n        background-size: 400% 400%;\r\n        opacity: 0.95;\r\n        z-index: 0;\r\n        transition: all 0.5s ease;\r\n    }\r\n\r\n    /* MODO OSCURO */\r\n    body.dark-mode .animated-gradient-bg {\r\n        /* Gradiente oscuro con toques sutiles de azul profundo */\r\n        background: linear-gradient(\r\n            135deg,\r\n            #0a0e1a 0%,\r\n            #121828 20%,\r\n            #1a1f3a 40%,\r\n            #0f1419 60%,\r\n            #0a0e1a 100%\r\n        );\r\n        background-size: 400% 400%;\r\n        opacity: 1;\r\n    }\r\n\r\n    /* Glows en modo oscuro */\r\n    body.dark-mode .right-glow-top {\r\n        opacity: 0.08;\r\n        background: radial-gradient(\r\n            circle, \r\n            rgba(99, 102, 241, 0.3) 0%,\r\n            rgba(67, 56, 202, 0.15) 40%,\r\n            transparent 70%\r\n        );\r\n        filter: blur(150px);\r\n    }\r\n\r\n    body.dark-mode .right-glow-bottom {\r\n        opacity: 0.06;\r\n        background: radial-gradient(\r\n            circle, \r\n            rgba(79, 70, 229, 0.25) 0%,\r\n            rgba(55, 48, 163, 0.12) 40%,\r\n            transparent 70%\r\n        );\r\n        filter: blur(140px);\r\n    }\r\n\r\n    /* Overlay en modo oscuro*/\r\n    body.dark-mode .right-panel-overlay {\r\n        background: linear-gradient(\r\n            135deg,\r\n            rgba(10, 14, 26, 0.4) 0%,\r\n            rgba(26, 31, 58, 0.3) 50%,\r\n            rgba(15, 20, 25, 0.4) 100% \r\n        );\r\n        backdrop-filter: blur(1px);\r\n        -webkit-backdrop-filter: blur(1px);\r\n    }\r\n\r\n    body.dark-mode .image-gradient-mask {\r\n        background: \r\n            linear-gradient(to right, \r\n                rgba(10, 14, 26, 0.9) 0%,\r\n                transparent 15%, \r\n                transparent 85%, \r\n                rgba(10, 14, 26, 0.9) 100%\r\n            ),\r\n            linear-gradient(to bottom, \r\n                rgba(10, 14, 26, 0.7) 0%, \r\n                transparent 15%, \r\n                transparent 85%, \r\n                rgba(10, 14, 26, 0.7) 100%\r\n            );\r\n    }\r\n\r\n    /* Texto en modo oscuro*/\r\n    body.dark-mode .hero-title {\r\n        color: #f0f4ff;\r\n        text-shadow: 2px 2px 12px rgba(0, 0, 0, 0.6);\r\n    }\r\n\r\n    body.dark-mode .highlight-text {\r\n        color: #c7d2fe;\r\n        text-shadow: 0 0 25px rgba(99, 102, 241, 0.4);\r\n    }\r\n\r\n    body.dark-mode .hero-desc {\r\n        color: rgba(226, 232, 240, 0.85);\r\n        text-shadow: 0 4px 15px rgba(0, 0, 0, 0.6);\r\n    }\r\n\r\n    /* Botones en modo oscuro */\r\n    body.dark-mode .animation-toggle-btn {\r\n        background: rgba(30, 41, 59, 0.6);\r\n        border: 1px solid rgba(99, 102, 241, 0.2);\r\n        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);\r\n    }\r\n\r\n    body.dark-mode .animation-toggle-btn:hover {\r\n        background: rgba(30, 41, 59, 0.8);\r\n        border-color: rgba(99, 102, 241, 0.3);\r\n        box-shadow: 0 6px 25px rgba(0, 0, 0, 0.5);\r\n    }\r\n\r\n    /* DEGRADADO (modo claro) */\r\n    .image-gradient-mask {\r\n        position: absolute;\r\n        inset: 0;\r\n        background: \r\n            linear-gradient(to right, \r\n                rgba(80, 56, 237, 0.8) 0%, \r\n                transparent 15%, \r\n                transparent 85%, \r\n                rgba(80, 56, 237, 0.8) 100%\r\n            ),\r\n            linear-gradient(to bottom, \r\n                rgba(80, 56, 237, 0.6) 0%, \r\n                transparent 15%, \r\n                transparent 85%, \r\n                rgba(80, 56, 237, 0.6) 100%\r\n            );\r\n        z-index: 1.5;\r\n        pointer-events: none;\r\n        transition: background 0.5s ease;\r\n    }\r\n    \r\n    /* OVERLAY / DIFUMINADO */\r\n    .right-panel-overlay {\r\n        position: absolute;\r\n        inset: 0;\r\n        background: linear-gradient(\r\n            135deg,\r\n            rgba(80, 56, 237, 0.1) 0%,\r\n            rgba(124, 104, 241, 0.05) 50%,\r\n            rgba(147, 51, 234, 0.1) 100%\r\n        );\r\n        backdrop-filter: blur(2px);\r\n        -webkit-backdrop-filter: blur(2px);\r\n        z-index: 2;\r\n        transition: all 0.5s ease;\r\n    }\r\n\r\n    /* Glows decorativos */\r\n    .right-glow-top, .right-glow-bottom {\r\n        position: absolute;\r\n        border-radius: 50%;\r\n        background: radial-gradient(circle, rgba(255, 255, 255, 0.4) 0%, transparent 70%);\r\n        filter: blur(120px);\r\n        opacity: 0.3;\r\n        pointer-events: none;\r\n        z-index: 3;\r\n        transition: all 0.5s ease;\r\n        animation: glow-pulse 4s ease-in-out infinite;\r\n    }\r\n    \r\n    .right-glow-top { \r\n        width: 600px; \r\n        height: 600px;\r\n        top: -10%; \r\n        right: -10%; \r\n        animation-delay: 0s;\r\n    }\r\n    \r\n    .right-glow-bottom { \r\n        width: 500px; \r\n        height: 500px;\r\n        bottom: -10%; \r\n        left: -10%; \r\n        background: radial-gradient(circle, rgba(255, 255, 255, 0.35) 0%, transparent 70%);\r\n        animation-delay: 2s;\r\n    }\r\n\r\n    /* CONTENIDO (Texto e Iconos) */\r\n    .right-panel-content {\r\n        position: relative;\r\n        z-index: 10;\r\n        max-width: 400px;\r\n    }\r\n\r\n    .hero-icon-box {\r\n        animation: subtle-pulse 6s ease-in-out infinite;\r\n    }\r\n\r\n    .hero-icon-box:active {\r\n        transform: scale(0.95);\r\n        animation: none;\r\n    }\r\n\r\n    .hero-title {\r\n        font-size: 2.5rem; \r\n        font-weight: 700; \r\n        line-height: 1.1;\r\n        margin-bottom: 1.5rem; \r\n        color: #ffffff;\r\n        text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);\r\n        transition: all 0.3s ease;\r\n    }\r\n\r\n    .highlight-text { \r\n        color: #ffffff;\r\n        text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);\r\n        transition: all 0.3s ease;\r\n    }\r\n\r\n    .hero-desc {\r\n        font-size: 1.1rem; \r\n        color: rgba(255, 255, 255, 0.9);\r\n        line-height: 1.6;\r\n        text-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\r\n        transition: all 0.3s ease;\r\n    }\r\n\r\n    /* Botones */\r\n    .animation-toggle-btn {\r\n        position: absolute;\r\n        bottom: 30px;\r\n        right: 30px;\r\n        width: 50px;\r\n        height: 50px;\r\n        border-radius: 50%;\r\n        background: rgba(255, 255, 255, 0.2);\r\n        backdrop-filter: blur(10px);\r\n        border: 1px solid rgba(255, 255, 255, 0.3);\r\n        color: white;\r\n        font-size: 1.2em;\r\n        cursor: pointer;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        z-index: 20;\r\n        transition: all 0.3s ease;\r\n        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .animation-toggle-btn:hover {\r\n        background: rgba(255, 255, 255, 0.3);\r\n        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\r\n    }\r\n}\r\n\r\n/* RESPONSIVE */\r\n@media (max-width: 1023px) {\r\n    .login-left-panel {\r\n        padding: 1.5rem;\r\n    }\r\n    \r\n    .login-card {\r\n        padding: 2rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
